import { render } from "./AccountSignupPage.vue?vue&type=template&id=2d3638ee&lang=true"
import script from "./AccountSignupPage.vue?vue&type=script&lang=js"
export * from "./AccountSignupPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__